import axios, {
  type AxiosInstance,
  type AxiosRequestHeaders,
  type ResponseType,
} from 'axios';

import { authInterceptor, responseAuthErrorInterceptor } from './interceptors';

export const client: AxiosInstance = axios.create();
client.interceptors.request.use(authInterceptor);
client.interceptors.response.use((res) => res, responseAuthErrorInterceptor);

type BaseParams = {
  url: string;
  headers: AxiosRequestHeaders;
};

export type GetParams = BaseParams & {
  queryParameters?: Record<string, string>;
  data?: unknown;
  responseType?: ResponseType;
};

export type PostParams = BaseParams & {
  body: Record<string, unknown>;
};

export type PostFormParams = BaseParams & {
  formData: FormData;
};

export type PutParams = BaseParams & {
  body: Record<string, unknown>;
};

export async function get<T>({
  url,
  queryParameters,
  headers,
  data,
  responseType,
}: GetParams): Promise<T> {
  const { data: response } = await client.get<T>(url, {
    responseType,
    data,
    headers,
    params: queryParameters,
  });

  return response;
}

export async function post<T>({ url, body, headers }: PostParams): Promise<T> {
  const { data } = await client.post<T>(url, body, { headers });
  return data;
}

export async function put<T>({ url, body, headers }: PutParams): Promise<T> {
  const { data } = await client.put<T>(url, body, { headers });
  return data;
}
